<template>
    <div class="text-center">
        <h1 class="my-4 text-lg font-semibold tracking-wider">you will receive the mail with bank detail</h1>
        <button v-show="!inProcess" class="px-8 py-2 text-xl tracking-wider text-center text-white bg-green-500 border rounded-md hover:border-green-500 hover:bg-green-100 hover:text-green-500" @click="subscribe">BOOK NOW</button>
        <button v-show="inProcess" class="px-8 py-2 text-xl tracking-wider text-center text-white bg-green-500 border rounded-md">
            <i class="fa fa-circle-o-notch fa-spin"></i> Processing
        </button>
    </div>
</template>
<script>
    export default {
        props: ['event', 'reservationData', 'mode'],
        data() {
            return {
                inProcess: false,
            }
        },
        methods: {
            subscribe(e) {
                this.inProcess = true;
                e.preventDefault();
                axios.post('/api/store/contact', {
                    type: 1,
                    email: this.reservationData.email,
                    name: this.reservationData.name,
                    last_name:this.reservationData.last_name,
                    phone: this.reservationData.phone,
                    company: this.reservationData.company,
                    role: this.reservationData.company_role,
                    event: this.event.id,
                    role: this.reservationData.job_role,
                    city: this.reservationData.city,
                    province: this.reservationData.province,
                    region: this.reservationData.region,
                    nation: this.reservationData.selectedCountry,
                    invoice_type: this.reservationData.invoice_type,
                    fiscal_code: this.reservationData.fiscal_code,
                    vat_number: this.reservationData.vat_number,
                    sd_code: this.reservationData.sd_code,
                    address: this.reservationData.address,
                    mode: this.mode,
                    fiscal_address:this.reservationData.fiscal_address,
                    fiscal_zipcode:this.reservationData.fiscal_zipcode,
                    fiscal_city:this.reservationData.fiscal_city,

                }).then(function (response) {
                    Swal.fire(
                        'Success!',
                        'Payment done successfully, Please check mail for more detail!!',
                        'success'
                    )
                    window.location.reload();
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
        }
    }
</script>